import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { actions as caregiverActions } from '../../redux/circles/caregiver';
import { actions as constantsActions } from '../../redux/data/constants';
import { actions as privacyPoliciesAction } from '../../redux/data/privacyPolicies';
import { actions as getLoggedUser } from '../../redux/profiles/get-logged-user';
import { actions as getTeamUser } from '../../redux/profiles/get-team-user';
import { actions as chatActions } from '../../redux/chatConnection';
import { setupSentryScope } from '../../utils/sentry/sentryMethods';
import { actions as countriesActions } from '../../redux/data/countries';
import { actions as guardianDependentsActions } from '../../redux/profiles/get-guardian-dependents';
import { actions as appStateActions } from '../../redux/data/app-state-req';
import {
  authTokenSelector,
  isLoggedInSelector,
} from '../../redux/auth/selectors';
import {
  loggedUserSelector,
  selectTeamUserId,
} from '../../redux/context/selectors';

const mapStateToProps = state => ({
  // check progress
  caregiver: state.circles.caregiver,
  consts: state.data.constants,
  // check conditions
  authToken: authTokenSelector(state),
  loggedIn: isLoggedInSelector(state),
  loggedUser: loggedUserSelector(state),
  getUserState: state.profiles.getUser,
  teamUserId: selectTeamUserId(state),
});

const mapDispatchToProps = {
  connectChat: chatActions.connect,
  getCaregiverCircles: caregiverActions.send,
  getConsts: constantsActions.send,
  getUser: getLoggedUser.send,
  privacyPolicies: privacyPoliciesAction.send,
  getGuardianDependents: guardianDependentsActions.send,
  fetchAppState: appStateActions.send,
  getTeamUser: getTeamUser.send,
  getCountries: countriesActions.send,
};

@connect(
  mapStateToProps,
  mapDispatchToProps,
)
export default class Requests extends React.Component {
  shouldComponentUpdate(nextProps) {
    const { authToken, loggedIn, loggedUser } = this.props;

    const authTokenReceived = nextProps.authToken && !authToken;
    const loginSucceed = nextProps.loggedIn && !loggedIn;
    const loggedUserReceived =
      !isEmpty(nextProps.loggedUser) && isEmpty(loggedUser);

    return authTokenReceived || loginSucceed || loggedUserReceived;
  }

  render() {
    const {
      // check progress
      caregiver,
      consts,
      // check conditions
      authToken,
      loggedIn,
      loggedUser,
      // actions
      connectChat,
      getCaregiverCircles,
      getConsts,
      getUserState,
      getUser,
      privacyPolicies,
      getGuardianDependents,
      fetchAppState,
      getTeamUser,
      getCountries,
      teamUserId,
    } = this.props;

    // needs authToken
    if (authToken && !consts.succeed && !consts.sending) getConsts();
    getCountries();
    privacyPolicies();
    // needs authToken and loggedUser
    if (loggedIn && !caregiver.succeed && !caregiver.sending)
      getCaregiverCircles();
    if (loggedIn) {
      getGuardianDependents();
      fetchAppState();
    }

    // get user
    // connect to app notifications
    if (
      loggedIn &&
      !getUserState.sending &&
      !getUserState.succeed &&
      get(loggedUser, 'id')
    ) {
      connectChat();
      getUser({ id: get(loggedUser, 'id') });
      const userId = get(loggedUser, 'id');

      setupSentryScope({ id: userId });
    }

    if (teamUserId) {
      getTeamUser({ id: teamUserId });
    }

    return null;
  }
}

Requests.propTypes = {
  caregiver: PropTypes.shape({
    sending: PropTypes.bool,
    succeed: PropTypes.bool,
  }),
  consts: PropTypes.shape({
    sending: PropTypes.bool,
    succeed: PropTypes.bool,
  }),
  // check conditions
  authToken: PropTypes.string,
  loggedIn: PropTypes.bool,
  loggedUser: PropTypes.shape({
    primaryPatientProfile: PropTypes.object,
  }),
  // actions
  connectChat: PropTypes.func,
  getCaregiverCircles: PropTypes.func,
  getConsts: PropTypes.func,
  getUser: PropTypes.func,
  getUserState: PropTypes.shape({
    sending: PropTypes.bool,
    succeed: PropTypes.bool,
  }),
  privacyPolicies: PropTypes.func,
  getGuardianDependents: PropTypes.func,
  getTeamUser: PropTypes.func,
  getCountries: PropTypes.func,
  fetchAppState: PropTypes.func,
  teamUserId: PropTypes.number,
};

Requests.defaultProps = {
  caregiver: {},
  consts: {},
  authToken: '',
  loggedIn: false,
  loggedUser: {},
  connectChat: () => {},
  getCaregiverCircles: () => {},
  getConsts: () => {},
  getUser: () => {},
  getUserState: {},
  privacyPolicies: () => {},
};



// WEBPACK FOOTER //
// ./src/components/App/Requests.jsx